function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#b58e3b"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M60 49.114a5 5 0 01-2.5 4.329l-25 14.444a5 5 0 01-5 0l-25-14.444A5 5 0 010 49.114v-28.9a5 5 0 012.5-4.329l25-14.44a5 5 0 015 0l25 14.445a5 5 0 012.5 4.329z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M55 20.219L30 5.775 5 20.219v28.895L30 63.56l25-14.445V20.22m5 0v28.895a5 5 0 01-2.499 4.33l-25 14.444a5 5 0 01-5.002 0l-25-14.444A5 5 0 010 49.114V20.22a5 5 0 012.499-4.33l25-14.444a5 5 0 015.002 0l25 14.445A5 5 0 0160 20.219z",
  fill: "rgba(255,255,255,.21)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.434 47.19a.738.738 0 01.742-.711c.363 0 8.8-.2 9.086-14.218h-6.139a.744.744 0 01-.672-.424.808.808 0 01-.066-.311.731.731 0 01.177-.479L31.38 18.26a.739.739 0 01.562-.259.747.747 0 01.566.259l10.818 12.787a.737.737 0 01-.563 1.214h-6.165c-.1 2-.754 7.531-4.865 11.506-3.223 3.112-7.8 4.523-13.6 4.185a.744.744 0 01-.7-.739zm14.508-27.311l-9.227 10.909h5.293a.737.737 0 01.739.735c0 6.134-1.454 10.689-4.318 13.542a10.7 10.7 0 01-1.5 1.238 13.758 13.758 0 007.777-3.6c4.539-4.39 4.429-11.09 4.433-11.165a.731.731 0 01.7-.753H41.173z",
  fill: "#fff"
});

var SvgAchievementUpsell = function SvgAchievementUpsell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 60 70",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAchievementUpsell, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AchievementUpsell.cac5fdbf.svg";
export { ForwardRef as ReactComponent };